import React from 'react';

import Link from './Link';

const RedLink = (props) => {
    return <Link red {...props} />;
}

export default RedLink;
